export * from './gutachten-gespeichert.interface';
